import React from 'react';
import { Space } from 'antd';
import Barcode from 'react-barcode';
import { tv } from 'tailwind-variants';
import { ButtonCommon } from '../Button/ButtonCommon';

const barcodeWrapper = tv({
  base: 'h-10 flex w-full gap-[10px]',
  variants: {
    size: {
      xs: 'h-6',
      sm: 'h-8',
      md: 'h-10',
      lg: 'h-14',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

interface BarcodeCommonProps {
  isDisabled?: boolean;
  valueBarcode: string;
  size?: 'sm' | 'md' | 'lg' | 'xs';
  onGenerate?: () => void;
  displayValue?: boolean;
  displayGenerate?: boolean;
  className?: string;
}

const BarcodeCommon: React.FC<BarcodeCommonProps> = ({
  valueBarcode,
  size,
  onGenerate,
  isDisabled,
  displayValue = true,
  displayGenerate = true,
  className,
}) => {
  if (!(valueBarcode || '').trim()) {
    return <div>Please provide a valid barcode value</div>;
  }

  return (
    <Space className={barcodeWrapper({ size }) + ' ' + className}>
      <Barcode value={valueBarcode} width={1.4} height={18} displayValue={displayValue} />
      {displayGenerate && (
        <ButtonCommon
          color='barcode'
          fullWidth
          radius='rounded'
          size='xs'
          onClick={onGenerate}
          isDisabled={isDisabled}
          className={`${isDisabled ? 'pointer-events-none' : ''}`}
        >
          Generate
        </ButtonCommon>
      )}
    </Space>
  );
};

export default BarcodeCommon;
